import { EventTypeId } from '@swf/sports/types/eventType';

import type { SectionWidgetConfig } from '../../types';
import { SportsWidgetType } from '../../widgets';
import { buildSportsLayoutPageResponse } from '../buildSportsLayoutPageResponse';

import {
  TXTWCL_Online_Sports_Betting_X_Odds,
  TXTWCL_Sports_Betting_Online___Welcom_ELL
} from './sportsHome.messages.json';

const sportsHomeWidgets: SectionWidgetConfig[] = [
  {
    title: 'Sports CMS Banner Widget',
    _content_type_uid: SportsWidgetType.SportsCmsBanner,
    boxShadow: true
  },
  {
    title: 'Sports Home Page Widget',
    _content_type_uid: SportsWidgetType.SportsHomePage
  },
  {
    title: 'Sports Home In-Play Widget',
    _content_type_uid: SportsWidgetType.SportsHomeInPlay
  },
  {
    title: 'Sports Upcoming Events Widget',
    _content_type_uid: SportsWidgetType.SportsUpcomingEvents
  },
  {
    title: 'Sports Next Races Widget',
    _content_type_uid: SportsWidgetType.SportsNextRaces,
    maxRunners: 3,
    condensed: true,
    eventTypeId: String(EventTypeId.HORSE_RACING)
  },
  {
    title: 'Sports Featured Widget',
    _content_type_uid: SportsWidgetType.SportsFeatured
  },
  {
    title: 'Sports Promotion Widget',
    _content_type_uid: SportsWidgetType.SportsPromotion,
    zoneId: 'BETSTARSMAIN'
  }
] as const;

export const sportsHome = buildSportsLayoutPageResponse({
  alias: 'sportsHome',
  seoConfig: {
    apiPath: '/meta/popular/',
    descriptionTag: TXTWCL_Sports_Betting_Online___Welcom_ELL,
    redirectStatusCode: 301,
    titleTag: TXTWCL_Online_Sports_Betting_X_Odds,
    translationsMap: {
      sport: 'popularEventTypes'
    }
  },
  mainSectionWidgetConfigs: sportsHomeWidgets
});
